<template>
	<div class="employerUserList">
		<!-- Main Body Content area -->
        <div class="o-main-content-area">
            <!-- Heading Section -->
            <div class="row c-responsive-fixwidth">
                <div class="col-md-3">
                    <h1 class="h1">Employer Group Users</h1>
                </div>
                <div class="col-md-9 text-right">
                    <ul class="o-filter-area">
            
                        <li class="o-search-field">
                            <div class="input-group stylish-input-group">
                                <input @input="getEmployers()" v-model="search_query" type="text" class="form-control" placeholder="Search">
                                <span class="input-group-addon">
                                    <button type="submit">
                                    <span class=""><i class="fa fa-search" aria-hidden="true"></i></span>
                                </button>
                                </span>
                            </div>
                        </li>
                        <li><router-link to="/addEmployerUser" class="c-common-btn c-common-btn--green"><i class="fa fa-plus" aria-hidden="true"></i> Add New User</router-link></li>

                        <!-- <li><a href="#" class="c-common-btn c-common-btn--red"><i class="fa fa-trash-o" aria-hidden="true"></i> Delete Employer</a></li> -->

                        <!-- <li><a href="#" class="c-common-btn c-solid-btn--blue"><i class="fa fa-upload" aria-hidden="true"></i> Import Through CSV</a></li> -->
                    </ul>

                </div>
            </div>
            <!-- /Heading Section -->
        </div>
        <div class="o-ndividualArea c-responsive-fixwidth">
            <div class="o-ndividualTable">
                <div class="c-common-space o-individual-calls">
                    <div class="col-md-12 o-no-padding">
                        <form class="form-inline">
                            <div class="form-group">
                                <label class="common-label-text">Sort By:</label>
                                <div class="o-cutsomSelect o-cutsomSelect--fixedwidth">
                                    <select  @change="getEmployers()" v-model="selectedShortType">
                                        <option value="fname_asc">FirstLast (Employer name)</option>
                                        <option value="fname_desc">LastFirst (Employer name)</option>
                                        <option value="email">Email</option>
                                    </select>
                                </div>
                            </div>
                            <!-- <button type="submit" class="c-common-btn c-common-btn--green">Go</button> -->
                        </form>
                    </div>
                </div>

                <div class="o-skills-listing">
                    <div class="row">

                        <div class="col col-sm-12">
                           <div class="o-scheduleTable--daily" v-loading="loading">

                                <div v-for="(employer,index) in employerList" :key="index" class="o-calls-table c-common-gradient c-common-box-shadow c-radius3 c-margin-bottom-10 employer-list-table-align">
                                        <div class="calls-table-row">

                                            <div class="calls-table-cell">
                                                <div class="table-td-border-right">
                                                    <div @click ="goToEmployerDetails(employer.id)" class="calls-table-cell-inner-table o-modal-trigger" data-toggle="modal" data-target="#employeeSummaryModal">
                                                        <div class="o-accordion-subtext user-icon">
                                                            <div class="o-post-logged o-post-logged--table-user">
                                                                <div class="o-user-profile-img">
                                                                    <img v-if="employer.user.image=='' || employer.user.image==null" src="static/assets/images/user1.png">
                                                                    <img v-else :src="employer.user.image">
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="o-accordion-subtext o-rowtable-text">
                                                            <span>Name</span>
                                                            <div>{{employer.user? employer.user.first_name:''}}</div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="calls-table-cell">
                                                <div class="table-td-border-right">
                                                    <div class="o-accordion-subtext o-rowtable-text">
                                                        <span>Email ID:</span>
                                                        <div>{{employer.user ? employer.user.email:''}}</div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="calls-table-cell">
                                                <div class="table-td-border-right">
                                                <div class="calls-table-cell-inner-table">
                                                    <div class="o-accordion-subtext o-rowtable-text">
                                                        <span>Secondary Email:</span>
                                                        <div>{{employer.user ? employer.user.secondary_email:''}}</div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            
                                            <div class="calls-table-cell">
                                                <div class="table-td-border-right">
                                                    <div class="o-accordion-subtext o-rowtable-text">
                                                        <span>Phone:</span>
                                                        <div v-for="phone in employer.user.phones" v-if="phone.label!='Fax'">{{phone.phone_number}}</div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="calls-table-cell">
                                                <div class="table-td-border-right">
                                                    <div class="o-accordion-subtext o-rowtable-text">
                                                        <span>FAX:</span>
                                                        <div v-for="phone in employer.user.phones" v-if="phone.label=='Fax'">{{phone.phone_number}}</div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="calls-table-cell">
                                                <div class="">
                                                    <div class="o-accordion-subtext o-rowtable-text o-notify-cell">
                                                        <span class="">Notify</span>
                                                        <div class="notify-icon"><i class="fa fa-mobile" aria-hidden="true"></i></div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="calls-table-cell text-center o-no-padding">
                                                <div class="o-edit-trash o-no-padding">

                                                    <div class="o-table-block-btn">
                                                        <router-link :to="'/editEmployerUser/'+getId(employer.id)"><i class="fa fa-pencil" aria-hidden="true"></i></router-link>
                                                    </div>
                                                    <div class="o-table-block-btn">
                                                        <a href="javascript: void(0)" :class="(employerUserId == employer.id)?'disabled':''" @click="deleteEmployer(employer.id)"><i class="fa fa-trash-o" aria-hidden="true"></i></a>
                                                    </div>

                                                </div>
                                            </div>
                                    </div>
                                </div>
                                
                            </div>
                        </div>

                    </div>
                </div>

            </div>
        </div>
        <!-- /Main Body Content area -->
	</div>
</template>
<script>
    import dateTimeConvert from '../../timeConvert&Compare';
    import {mapGetters, mapActions} from 'vuex';
    import service from '../../services.js';
    export default {
        data() {
            return {
                employerList:{},
                selectedShortType:'fname_asc',
                search_query:'',
                loading:true,
            }
        },
        computed: {
            ...mapGetters({

                userToken: 'userToken',
                userID :'userID',
                companyId : 'companyId',
                employerUserId: 'employerUserId',
            })
        },
        methods: {
            getId(id){
                //console.log('id',id);
                return btoa(id);
            },
            goToEmployerDetails(id){
                this.$router.push({
                    'path': '/empoyerProfile/'+btoa(id)
                });
            },
            getEmployers(){
                this.employerList={}
                this.loading=true;
                service.get('employer/'+this.companyId+'/getAllEmployerUsers', {
                    'Authorization': this.userToken,
                    'sort': this.selectedShortType,
                    'search': this.search_query,
                }).then((res) => {
                    this.loading=false;
                    this.employerList = res.data.result.employer_users
                    //console.log(res);
                }).catch((err) => {
                    this.loading=false;
                    console.log('error',err);
                    this.$message({
                        type: 'error',
                        message: 'Sorry, Something Went Wrong: Please try again later.'
                    });
                });   
            },
            deleteEmployer(id){
                this.$confirm('This will permanently delete the file. Continue?', 'Warning', {
                    confirmButtonText: 'OK',
                    cancelButtonText: 'Cancel',
                    type: 'warning'
                }).then(() => {

                    service.del('employer/'+id+'/deleteSingleEmployerUser', {
                        'Authorization': this.userToken
                    }).then((res) => {
                        this.getEmployers();
                        this.$message({
                            type: 'success',
                            message: 'Employer deleted.'
                        });
                    }).catch((err) => {
                        console.log('error',err);
                        this.$message({
                            type: 'error',
                            message: 'Sorry, Something Went Wrong: Please try again later.'
                        });
                    }); 
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: 'Delete canceled'
                    });
                });
            }
             
       	},
        mounted() {
           
        },
        created() {
            this.getEmployers();
        }
    }

</script>
<style scoped>


</style>
